<div class="asset-finance-calcualtor-page container-fluid">
<div class="calculator-content mt-4" [formGroup]="formGroupCalculator">

  <div class="section-format mt-1 p-4 quote-toggle-section">
    <div class="col-md-10 text-center">
      <h5 class="quote-toggle-title">Get the quote based on</h5>
      <mat-button-toggle-group class="quote-toggle-group col-md-6" [formControl]="formControlQuoteType">
        <mat-button-toggle value="application">
          Application information
        </mat-button-toggle>
        <mat-button-toggle value="interest">
          Interest rate
        </mat-button-toggle> 
      </mat-button-toggle-group>
    </div>
  </div>

  <!-- Application Information Content -->
  @if (formControlQuoteType.value === 'application') {
  <div>

  <div class="section-format mt-1 p-4">
    <div class="row main">
      <div class="col-md-10">
        <h3>Risk profile</h3>
      </div>
      <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">1/6</span></div>
    </div>
    
    <div class="mat-body separator-bottom row col-md-6">
      Please provide us with further details so we can provide you with a more accurate quote
    </div>

    <div class="row main">
      <div class="col-lg-3 col-md-12">
        <yes-no title="Property owner" [formControl]="formControlPropertyOwner" [mark]="markTriggerSubject(formGroupCalculator)"></yes-no>
      </div>
      <div class="col-lg-3 col-md-12">
        <yes-no title="Adverse on file" [formControl]="formControlAdverseOnFile" [mark]="markTriggerSubject(formGroupCalculator)"></yes-no>
      </div>
    </div>
    <div class="row main">
      <div class="col-lg-3 col-md-12">
        <yes-no title="Director Equifax score > 550" [formControl]="formControlEquifaxScoreAboveThreshold" [mark]="markTriggerSubject(formGroupCalculator)"></yes-no>
      </div>
      <div class="col-lg-3 col-md-12">
        <yes-no title="Equifax Director Score above 700" [formControl]="formControlEquifaxDirectorScoreAbove700" [mark]="markTriggerSubject(formGroupCalculator)"></yes-no>
      </div>
    </div>
    <div class="row main">
      <div class="col-lg-6 col-md-12">
        <business-search 
          [placeholder]="'Search by ABN or name'" 
          [formControl]="formControlBusiness" 
          [searchFn]="businessSearchFn"
          [required]="false"
          [allowFreeText]="false"
          [label]="'Get the ABN age by lookup'"
        >
        </business-search>
      </div>
      <div class="col-lg-3 col-md-12">
        <mat-form-field>
          <mat-label>ABN age (months)</mat-label>
          <input matInput [formControl]="formControlAbnAge" type="number" min="0">
          <mat-hint>Enter ABN age in months or use business lookup</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="section-format mt-1 p-4">
    <div class="row">
      <div class="col-md-10">
        <h3>Asset details</h3>
      </div>
      <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">2/6</span></div>
    </div>
    <div class="mat-body separator-bottom">Please provide details on the asset you would like to finance.</div>
    <div class="row separator-bottom">
      <div class="col">
        <asset-selection  [searchFn]="AssetSearchFn" [formControl]="formControlAsset"  [categoryIndexFilter]="assetCategoryIndexFilter"  [mark]="markTriggerSubject(formGroupCalculator)" [forceSimpleMode]="true">
        </asset-selection>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-12">
        <asset-condition  
          [formControl]="formControlAssetCondition" 
          [mark]="markTriggerSubject(formGroupCalculator)"
          [assetCategory]="formControlAsset.value?.category?.index ?? null"
          [assetYear]="parseAssetYear(formControlAsset.value?.year)">
        </asset-condition>
      </div>
      <div class="col-lg-3 col-md-12">
        <transaction-type-selection  [formControl]="formControlTransactionType"  [mark]="markTriggerSubject(formGroupCalculator)"></transaction-type-selection>
      </div>
    </div>
  </div>

  <div class="section-format mt-1 p-4">
    <div class="row main">
      <div class="col-md-10">
        <h3>Finance details</h3>
      </div>
      <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">3/6</span></div>
    </div>

    <div class="mat-body separator-bottom">Let us know your preferred repayment terms</div>

    <div class="row main mt-3">
      <div class="col-lg-3 col-md-12">
        <finance-type-selection  [formControl]="formControlFinanceType"
          [mark]="markTriggerSubject(formGroupCalculator)"
        [optionsFilter]="ASSET_FINANCE_OPTIONS_FILTER"></finance-type-selection>
      </div>
      <div class="col-lg-3 col-md-12">
        <yes-no  title="Doc Fee financed" [formControl]="formControlDocFeeFinanced"
        [mark]="markTriggerSubject(formGroupCalculator)"></yes-no>
      </div>
    </div>

    <div class="row main">
      <div class="col-lg-3 col-md-12">
        <loan-terms-selection  [formControl]="formControlLoanTerms" [mark]="markTriggerSubject(formGroupCalculator)" [maxTerm]="maxLoanTerm"></loan-terms-selection>
      </div>
      <div class="col-lg-3 col-md-12">
        <payment-frequency-selection  [formControl]="formControlPaymentFrequency" [mark]="markTriggerSubject(formGroupCalculator)">
        </payment-frequency-selection>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-12">
        <currency-input 
          [title]="formControlFinanceType.value?.type === 'rental' ? 'Invoice amount (ex GST)' : 'Invoice amount (incl GST)'"
          [hint]="formControlFinanceType.value?.type === 'rental' ? 'Invoice amount must exclude GST' : 'Invoice amount must include GST'"
          [formControl]="formControlInvoiceAmount" 
          [mark]="markTriggerSubject(formGroupCalculator)">
        </currency-input>
      </div>
      <div class="col-lg-3 col-md-12">
        <currency-input title="Deposit amount" [min]="depositMin" [max]="depositMax"  [formControl]="formControlDepositAmount" [mark]="markTriggerSubject(formGroupCalculator)"></currency-input>
      </div>
    </div>

    <div class="row ml-1">
      <div class="col-lg-6 col-md-12" class="balloonWidth">
        <balloon-payment #balloonPaymentComponent="balloonPaymentComponent"  [formControl]="formControlBalloonPayment" [mark]="markTriggerSubject(formGroupCalculator)"></balloon-payment>
      </div>
    </div>
  </div>

  <div class="section-format mt-1 p-4">
    <div class="row">
      <div class="col-md-10">
        <h3>Brokerage details</h3>
      </div>
      <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">4/6</span></div>
    </div>
    <div class="mat-body separator-bottom row col-md-6">Enter your origination fee (dollar amount up to $900 ex GST) and brokerage of amount financed (up to 6%)</div>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <currency-input title="Origination Fee(ex GST)" [min]="0" [formControl]="formControlBrokerOriginationFee" [mark]="markTriggerSubject(formGroupCalculator)"></currency-input>
        @if ((formControlBrokerOriginationFee.value ?? 0) > 900 ) {
          <div class="Warning">Warning:Your origination fee exceeds the limit. </div>
        }
      </div>
      <div class="col-lg-3 col-md-12">
        <brokerage-selection  [max]="ASSET_FINANCE_MAX_BROKERAGE_PERCENT" [formControl]="formControlBrokerage" [mark]="markTriggerSubject(formGroupCalculator)"></brokerage-selection>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12" fxLayout="row" fxLayoutAlign="end center">
      <button mat-flat-button color="primary" class="w-lt-md-100" (click)="onCalculateEstimation($event)">Calculate repayment</button>
    </div>
  </div>

  </div>
  }

  <!-- Interest Rate Content -->
  @if (formControlQuoteType.value === 'interest') {
  <div>
    <div class="section-format mt-1 p-4">
      <div class="row main">
        <div class="col-md-10">
          <h3>Interest Rate </h3>
        </div>
          <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">1/3</span></div>
          </div>
          <div class="row main mt-3">
          <div class="col-lg-3 col-md-12">
          <mat-form-field>
            <mat-label>interest rate</mat-label>
            <input matInput [inputMask]="inputMaskTwoDecimal" [formControl]="formControlInterestRate" type="text"  required>
            <span class="mdi mdi-percent" matSuffix></span>
          </mat-form-field>
        </div>
        </div>
      </div>
    <div class="section-format mt-1 p-4">
      <div class="row main">
        <div class="col-md-10">
          <h3>Finance details</h3>
        </div>
        <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">2/3</span></div>
      </div>
  
      <div class="mat-body separator-bottom">Let us know your preferred repayment terms</div>
  
      <div class="row main mt-3">
        <div class="col-lg-3 col-md-12">
          <finance-type-selection  [formControl]="formControlFinanceTypeInterest"
            [mark]="markTriggerSubjectInterest"
          [optionsFilter]="ASSET_FINANCE_OPTIONS_FILTER"></finance-type-selection>
        </div>
        <div class="col-lg-3 col-md-12">
          <yes-no  title="Doc Fee financed" [formControl]="formControlDocFeeFinancedInterest"
          [mark]="markTriggerSubjectInterest"></yes-no>
        </div>
      </div>
  
      <div class="row main">
        <div class="col-lg-3 col-md-12">
          <loan-terms-selection  [formControl]="formControlLoanTermsInterest" [mark]="markTriggerSubjectInterest" [maxTerm]="maxLoanTerm"></loan-terms-selection>
        </div>
        <div class="col-lg-3 col-md-12">
          <payment-frequency-selection  [formControl]="formControlPaymentFrequencyInterest" [mark]="markTriggerSubjectInterest">
          </payment-frequency-selection>
        </div>
      </div>
  
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <currency-input 
            [title]="formControlFinanceTypeInterest.value?.type === 'rental' ? 'Invoice amount (ex GST)' : 'Invoice amount (incl GST)'"
            [hint]="formControlFinanceTypeInterest.value?.type === 'rental' ? 'Invoice amount must exclude GST' : 'Invoice amount must include GST'"
            [formControl]="formControlInvoiceAmountInterest" 
            [mark]="markTriggerSubjectInterest">
          </currency-input>
        </div>
        <div class="col-lg-3 col-md-12">
          <currency-input title="Deposit amount"  [formControl]="formControlDepositAmountInterest" [mark]="markTriggerSubjectInterest"></currency-input>
        </div>
      </div>
  
      <div class="row ml-1">
        <div class="col-lg-6 col-md-12" class="balloonWidth">
          <balloon-payment #balloonPaymentComponent="balloonPaymentComponent"  [formControl]="formControlBalloonPaymentInterest" [mark]="markTriggerSubjectInterest"></balloon-payment>
        </div>
      </div>
    </div>
    <div class="section-format mt-1 p-4">
      <div class="row">
        <div class="col-md-10">
          <h3>Brokerage details</h3>
        </div>
        <div class="col-md-2" fxLayoutAlign="end center"><span class="text-muted">3/3</span></div>
      </div>
      <div class="mat-body separator-bottom row col-md-6">Enter your origination fee (dollar amount up to $900 ex GST) and brokerage of amount financed (up to 6%)</div>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <currency-input title="Origination Fee(ex GST)" [min]="0" [formControl]="formControlBrokerOriginationFeeInterest" [mark]="markTriggerSubjectInterest"></currency-input>
          @if ((formControlBrokerOriginationFeeInterest.value ?? 0) > 900 ) {
            <div class="Warning">Warning:Your origination fee exceeds the limit. </div>
          }
        </div>
        <div class="col-lg-3 col-md-12">
          <brokerage-selection  [max]="ASSET_FINANCE_MAX_BROKERAGE_PERCENT" [formControl]="formControlBrokerageInterest" [mark]="markTriggerSubjectInterest"></brokerage-selection>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12" fxLayout="row" fxLayoutAlign="end center">
        <button mat-flat-button color="primary" class="w-lt-md-100" (click)="onCalculateEstimationInterestRate($event)">Calculate repayment</button>
        </div>
      </div>
  </div>
  }
</div>
</div>